/* THIS FILE IS AUTO-GENERATED – DO NOT EDIT */

import {forwardRef} from 'react'

/**
 * @public
 */
export const TimelineIcon = forwardRef(function TimelineIcon(
  props: React.SVGProps<SVGSVGElement>,
  ref: React.Ref<SVGSVGElement>,
) {
  return (
    <svg
      data-sanity-icon="timeline"
      width="1em"
      height="1em"
      viewBox="0 0 25 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      ref={ref}
      {...props}
    >
      <path d="M12.5 5V20" stroke="currentColor" strokeWidth={1.2} />
      <path
        d="M5 8.5H11M7 12.5H11M9 16.5H11M13 16.5H20M13 12.5H18M13 8.5H16"
        stroke="currentColor"
        strokeWidth={1.2}
      />
    </svg>
  )
})
TimelineIcon.displayName = 'ForwardRef(TimelineIcon)'
